import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="mt-24 border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-12 lg:px-10">
        <div className="md:col-span-5">
          <img src="/vaya-logo.png" alt="Vaya Hotel Transfers" className="h-14 w-auto" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600">{t("footer.tag")}</p>
        </div>
        <div className="md:col-span-3">
          <p className="label-eyebrow">Airports</p>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li>Antalya Airport (AYT)</li>
            <li>Gazipaşa Alanya (GZP)</li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="label-eyebrow">Regions</p>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li>Kemer · Beldibi · Göynük</li>
            <li>Lara · Belek · Side · Manavgat</li>
            <li>Alanya · Avsallar · Gazipaşa</li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3 border-t border-slate-200 px-5 py-5 text-center text-xs text-slate-500 sm:flex-row sm:justify-between lg:px-10">
        <span>
          © {new Date().getFullYear()} Vaya Hotel Transfers. {t("footer.rights")}
        </span>
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          className="font-semibold text-slate-600 underline transition-colors duration-200 hover:text-sea"
        >
          {t("legal.privacyLink")}
        </Link>
        <Link
          to="/terms"
          data-testid="footer-terms-link"
          className="font-semibold text-slate-600 underline transition-colors duration-200 hover:text-sea"
        >
          {t("legal.termsLink")}
        </Link>
        <Link
          to="/delete-account"
          data-testid="footer-delete-account-link"
          className="font-semibold text-slate-600 underline transition-colors duration-200 hover:text-sea"
        >
          {t("del.title")}
        </Link>
      </div>
    </footer>
  );
};
